const TYPES = {
  Services: {
    // Core Services
    AppStateService: Symbol("AppStateService"),
    ConfigService: Symbol("ConfigService"),
    SecurityService: Symbol("SecurityService"),
    // Entity Services
    AppointmentService: Symbol("AppointmentService"),
    ItemsService: Symbol("ItemsService"),
    VisitourService: Symbol("VisitourService"),
  }
};

export { TYPES };